import React from "react";
import { Edit } from "lucide-react";
import { getFinanceCategoryColor, getFinanceCategoryIcon } from "./financeConstants";
import { parseAmount } from "./financeUtils";

export default function FinanceDesktopTransactionCard({
  item,
  onEdit,
  readOnlyMode,
  selectedDepartment,
  getDepartmentColor,
}) {
  return (
    <div
      onClick={() => !readOnlyMode && onEdit(item)}
      className={`
        group relative overflow-hidden rounded-[2rem] p-6 transition-all duration-300 ${readOnlyMode ? "cursor-default" : "cursor-pointer hover:-translate-y-2 hover:shadow-2xl"}
        ${item.type === "수입"
          ? "bg-gradient-to-br from-white/95 to-blue-50/90 border-blue-100/50"
          : "bg-gradient-to-br from-white/95 to-rose-50/90 border-rose-100/50"}
        backdrop-blur-2xl border shadow-lg ring-1 ring-white/50
      `}
    >
      <div className="absolute -right-6 -top-6 w-32 h-32 bg-white/40 rounded-full blur-2xl transition-all group-hover:scale-150 duration-700"></div>

      <div className="relative z-10 flex flex-col h-full justify-between gap-4">
        <div className="flex justify-between items-start">
          <span className="text-xs font-bold text-gray-400 bg-white/50 px-3 py-1 rounded-full backdrop-blur-sm shadow-sm border border-white/50">
            {item.date.slice(5)}
          </span>
          <span className={`text-[10px] font-black px-2.5 py-1 rounded-lg shadow-sm text-white ${getFinanceCategoryColor(item.category)}`}>
            {item.category}
          </span>
        </div>

        {selectedDepartment === "All" && item.department && item.department !== "All" && (
          <div className="absolute top-12 left-1/2 -translate-x-1/2 z-20">
            <span className={`text-[10px] font-bold text-white px-2 py-0.5 rounded-full border border-white/20 shadow-md backdrop-blur-md ${getDepartmentColor(item.department)}`}>
              {item.department}
            </span>
          </div>
        )}

        <div className="flex flex-col items-center text-center gap-2">
          <div className="w-16 h-16 relative mt-4">
            <div className="absolute inset-0 bg-white/30 rounded-full blur-xl animate-pulse-slow"></div>
            <img
              src={getFinanceCategoryIcon(item.category)}
              alt={item.category}
              className="w-full h-full object-contain drop-shadow-md transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6"
            />
          </div>
          <h4 className="font-bold text-gray-700 text-lg line-clamp-1 w-full px-2">
            {item.description}
          </h4>
        </div>

        <div className={`mt-auto pt-4 border-t border-black/5 flex justify-center items-baseline gap-1 font-black font-do-hyeon text-2xl ${item.type === "수입" ? "text-blue-500" : "text-rose-500"}`}>
          <span className="text-lg opacity-70">{item.type === "수입" ? "+" : "-"}</span>
          {parseAmount(item.amount).toLocaleString()}
          <span className="text-sm opacity-50 font-sans font-bold text-gray-400">원</span>
        </div>
      </div>

      {!readOnlyMode && (
        <div className="absolute inset-0 z-50 bg-black/5 backdrop-blur-[1px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-start justify-center pt-8 pointer-events-none">
          <div className="bg-white/95 text-gray-800 px-4 py-2 rounded-full font-bold shadow-xl transform -translate-y-4 group-hover:translate-y-0 transition-transform duration-300 flex items-center gap-2 border border-white/50">
            <Edit size={16} /> 수정하기
          </div>
        </div>
      )}
    </div>
  );
}
